import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  // Secret key for encryption - should be stored securely in environment
  private readonly SECRET_KEY = 'Luqta@Admin#2024$SecureKey!';
  private readonly SALT = 'LuqtaAdminPortal';

  /**
   * Encrypts data using AES-like algorithm with Base64 encoding
   */
  encrypt(data: string): string {
    if (!data) return '';

    try {
      // Create a key from secret
      const key = this.generateKey();

      // XOR encryption with key
      let encrypted = '';
      for (let i = 0; i < data.length; i++) {
        const charCode = data.charCodeAt(i) ^ key.charCodeAt(i % key.length);
        encrypted += String.fromCharCode(charCode);
      }

      // Add salt and encode to Base64
      const saltedData = this.SALT + encrypted + this.SALT;
      return btoa(encodeURIComponent(saltedData));
    } catch (error) {
      console.error('Encryption error:', error);
      return '';
    }
  }

  /**
   * Decrypts data that was encrypted using the encrypt method
   */
  decrypt(encryptedData: string): string {
    if (!encryptedData) return '';

    try {
      // Decode from Base64
      const saltedData = decodeURIComponent(atob(encryptedData));

      // Remove salt
      const encrypted = saltedData.slice(
        this.SALT.length,
        saltedData.length - this.SALT.length
      );

      // Create key from secret
      const key = this.generateKey();

      // XOR decryption with key
      let decrypted = '';
      for (let i = 0; i < encrypted.length; i++) {
        const charCode =
          encrypted.charCodeAt(i) ^ key.charCodeAt(i % key.length);
        decrypted += String.fromCharCode(charCode);
      }

      return decrypted;
    } catch (error) {
      console.error('Decryption error:', error);
      return '';
    }
  }

  /**
   * Generates encryption key from secret
   */
  private generateKey(): string {
    let key = '';
    for (let i = 0; i < this.SECRET_KEY.length; i++) {
      key += String.fromCharCode(
        this.SECRET_KEY.charCodeAt(i) ^ this.SALT.charCodeAt(i % this.SALT.length)
      );
    }
    return key;
  }

  /**
   * Validates if data appears to be encrypted
   */
  isEncrypted(data: string): boolean {
    if (!data) return false;

    try {
      const decoded = decodeURIComponent(atob(data));
      return (
        decoded.startsWith(this.SALT) && decoded.endsWith(this.SALT)
      );
    } catch {
      return false;
    }
  }
}
